import { useCallback, useState } from 'react';
import { omit } from 'lodash';
import { useDeliverEvent } from '@ion/api';

import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import translatePipelineIntegration from 'app/shared/translation/integrations/translatePipelineIntegration';

export default function useServerResponse({ integrationOutput, pipelineIntegration, originalEvent }) {
  const { pipeline } = usePipelinePageContext();
  const [sendEventConfirmed, setSendEventConfirmed] = useState(false);
  const [executeDeliverEvent, deliverEventResponse] = useDeliverEvent();

  const onConfirmSendEvent = () => {
    setSendEventConfirmed(true);
    // Try to double check this only ever gets called once
    if (!deliverEventResponse.called) {
      executeDeliverEvent(
        buildDeliverEventInput({
          pipeline,
          integrationOutput,
          pipelineIntegration,
          originalEvent,
        })
      );
    }
  };

  const reset = useCallback(() => {
    setSendEventConfirmed(false);
    deliverEventResponse.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliverEventResponse.reset]);

  return {
    ...deliverEventResponse,
    sendEventConfirmed,
    onConfirmSendEvent,
    reset,
  };
}

export function buildDeliverEventInput({ pipeline, integrationOutput, pipelineIntegration, originalEvent }) {
  return {
    clusterId: pipeline.cluster.id,
    integration: buildConnectionOnlyIntegration(pipelineIntegration),
    inputEvent: integrationOutput.outputEvent,
    originalEvent,
  };
}

// Since the deliver_events takes the already transformed event, it doesn't
// need the transformStages, just the connection.
// Omitting here so that if for some reason it tries to transform it will fail
function buildConnectionOnlyIntegration(pipelineIntegration) {
  const translatedPlaybook = translatePipelineIntegration(pipelineIntegration);
  return omit(translatedPlaybook, 'transformStages');
}
